import { render, staticRenderFns } from "./form3.vue?vue&type=template&id=2f3e4541&scoped=true&"
import script from "./form3.vue?vue&type=script&lang=js&"
export * from "./form3.vue?vue&type=script&lang=js&"
import style0 from "./form3.vue?vue&type=style&index=0&id=2f3e4541&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3e4541",
  null
  
)

export default component.exports